module.exports = __webpack_public_path__ + "img/connect.7ff6ca1b.webp";